<template>
  <div id="showScroll" class="container-ticket">
    <div class="receipt container-ticket" v-bind:style="ancho">
      <h1 class="main-title"></h1>
      <div class="address" style="font-size: 16px">
        {{ title.message }}
      </div>
      <div class="centerItem transactionDetails">
        Cajero:{{ getCashierName }}
      </div>
      <div class="centerItem transactionDetails">
        {{fecha}}
      </div>
      <div class="centerItem bold">
        <div class="item">Corte de caja</div>
      </div>
      <div class="transactionDetails" id="tablaDetalle">
        <table></table>
      </div>
      <div class="survey bold">
        <p>Detalle</p>
        <p class="surveyID"></p>
      </div>

      <template v-for="(cont, index) in dataToTicket">
        <div :key="index" v-if="cont.show">
          <div class="bold" style="margin-top: 10px; margin-bottom: 20px">
            <p>{{ cont.Nombre }}</p>
          </div>
          <div v-if="cont.Clave == 'EFVO_MXN'" class="paymentDetails bold">
            <div class="detail">Fondo</div>
            <div class="detail">
              {{
                $pgsHelper.formatNumber($pgsHelper.roundDecimals(cont.Fondo))
              }}
            </div>
          </div>
          <div class="paymentDetails bold">
            <div class="detail">Teórico</div>
            <div class="detail">
              {{
                $pgsHelper.formatNumber($pgsHelper.roundDecimals(cont.Sistema))
              }}
            </div>
          </div>
          <div v-if="cont.Propinas > 0" class="paymentDetails bold">
            <div class="detail">Teórico con Propinas</div>
            <div class="detail">
              {{
                $pgsHelper.formatNumber(
                  $pgsHelper.roundDecimals(cont.Sistema + cont.Propinas)
                )
              }}
            </div>
          </div>
          <div class="paymentDetails bold">
            <div class="detail">Real</div>
            <div class="detail">
              {{
                $pgsHelper.formatNumber($pgsHelper.roundDecimals(cont.Contador))
              }}
            </div>
          </div>
          <div class="paymentDetails bold">
            <div class="detail">Diferencia</div>
            <div class="detail">
              {{
                $pgsHelper.formatNumber(
                  $pgsHelper.roundDecimals(cont.Diferencia)
                )
              }}
            </div>
          </div>
        </div>
      </template>

      <div class="paymentDetails" v-if="cnta != 0" style="margin-top: 20px">
        <div class="detail">Cuentas por cobrar</div>
        <div class="detail">
          {{ $pgsHelper.formatNumber($pgsHelper.roundDecimals(cnta)) }}
        </div>
      </div>
      <div class="centerItem bold">
        <div class="item">Propinas</div>
      </div>
      <div v-if="propinas">
        <template v-for="(prop, key) in propinas">
          <div
            v-if="key != 'CARDS_MXN' && key != 'CARDS_USD'"
            :key="key"
            class="paymentDetails"
          >
            <div class="detail">{{ prop.Nombre }}</div>
            <div class="detail">
              {{
                $pgsHelper.formatNumber($pgsHelper.roundDecimals(prop.Cantidad))
              }}
            </div>
          </div>
        </template>
        <div class="paymentDetails">
          <div class="detail"><b>Total Propina Pesos</b></div>
          <div class="detail">
            <b>{{
              $pgsHelper.formatNumber($pgsHelper.roundDecimals(totalProp.total))
            }}</b>
          </div>
        </div>
        <div class="paymentDetails">
          <div class="detail"><b>Total Propina USD</b></div>
          <div class="detail">
            <b>{{
              $pgsHelper.formatNumber(
                $pgsHelper.roundDecimals(totalProp.totalUSD)
              )
            }}</b>
          </div>
        </div>
      </div>
      <div style="margin-top: 40px" class="survey bold">
        <p style="border-top: solid 1px #000">Firma Cajero</p>
        <p class="surveyID"></p>
      </div>
      <div style="margin-top: 50px" class="survey bold">
        <p style="border-top: solid 1px #000">Firma Encargado</p>
        <p class="surveyID"></p>
      </div>

      <div v-if="dataToTicket.notaCaja != ''" class="creditDetails">
        <div class="survey bold">
          <p>Explicación diferencia</p>
          <p class="surveyID"></p>
        </div>
        {{ dataToTicket.notaCaja }}
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/css/ticket.css";
import { mapGetters } from "vuex";

export default {
  name: "corteCajaPrint",
  components: {},
  props: ["dataToTicket", "getCashierName", "propinas","fecha"],
  data() {
    return {
      datetime: new Date(),
      textTicket: "",
      titleTicket: "",
    };
  },
  computed: {
    //...mapGetters(["getCashierName"]),
    cnta() {
      let cuenta = this.$pgsHelper.getById(this.dataToTicket, "Clave", "CNTA");
      if (cuenta) {
        return cuenta.Sistema;
      }
      return 0;
    },
    totalProp() {
      try {
        let dataProp = Object.entries(this.propinas);
        let total = 0;
        let totalUSD = 0;
        dataProp.forEach((element) => {
          
          if (element[0] != "CARDS_MXN" && element[0] != "CARDS_USD") {
            if (element[1].Moneda == this.$Currencies.getCurrencyDefault()) {
              total = total + Number(element[1].Cantidad);
            } else {
              totalUSD = totalUSD + Number(element[1].Cantidad);
            }
            
          }
        });
        return { total: total, totalUSD: totalUSD };
      } catch (e) {
        console.log(e);
        return { total: 0, totalUSD: 0 };
      }
    },
    ancho() {
      let ancho = "80mm"
        /*this.$pgsHelper.getConfig("anchoTicket") == "full"
          ? "100%"
          : this.$pgsHelper.getConfig("anchoTicket") + "mm";*/
      let style = {
        width: ancho,
      };
      return style;
    },
    title() {
      let message = {
        show: true,
        message: this.titleTicket,
      };
      return message;
    },
  },
  methods: {
    getPropinaByPayment(clave, mnd) {
      try {
        if (!this.dataToTicket.propinas) {
          return false;
        }
        let dataProp = Object.entries(this.dataToTicket.propinas.monedas);
        let total = 0;
        dataProp.forEach((element) => {
          if (element[1].Pago == clave && element[1].Moneda == mnd) {
            total = total + Number(element[1].Cantidad);
          }
          if (clave === "CARDS") {
            if (element[1].Pago === "VISA" && element[1].Moneda == mnd) {
              total = total + Number(element[1].Cantidad);
            }
            if (element[1].Pago === "MACA" && element[1].Moneda == mnd) {
              total = total + Number(element[1].Cantidad);
            }
          }
        });
        if (total > 0) {
          return total;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
  },
  mounted: function () {
    /*var prods = localStorage.getItem('productos');
        document.getElementById('tablaDetalle').innerHTML = prods;
        this.$pgsHelper.log(this.pagos);*/
    //const contents = this.$electron.remote.webContents.getFocusedWebContents();
    //contents.print({silent: true});

    this.$pgsHelper.log(this.dataToTicket);
  },
  beforeMount: function () {
    let config = {} //this.$pgsHelper.configuracionDepartamento(this);
    /*configuracionDepartamento*/

    this.titleTicket = config.Tickets?.TitleTicket;
    /*this.$electron.ipcRenderer.on('store-data', function (event,store) {
        this.$pgsHelper.log(store);
    });
    this.$emit('useNav',false);*/
  },
};
</script>
